export default __webpack_public_path__ + "static/media/AutonomousVehicleTrans.c5473066.png";